import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'

const ActiveInactiveComponent = ({ isActive, setOpenToggle, handleConfirmToggle, loading, openToggle }: any) => {
    console.log("isActive", isActive)
    return (
        //    are you confrim active or inctive Dialog
        <Dialog open={openToggle} onClose={() => setOpenToggle(false)}>
            <DialogTitle>Confirmation</DialogTitle>
            <DialogContent>
                Are you sure you want to {isActive === true ? 'deactivate' : 'activate'}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenToggle(false)} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirmToggle}
                    color="primary"
                    variant="contained"
                    disabled={loading}
                >
                    {loading ? 'Updating...' : isActive ? 'Deactivate' : 'Activate'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ActiveInactiveComponent